import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import NoPhotoImage from './imgs/nophoto.png';
import ModalHead from './ModalHead';
import {Girl} from "./Inc";
import {Styles} from './Styles';
import { Theme } from './Theme';

interface Props {
    girls:Girl[],
    index:number,
    lost:string,
    unlockedIndex:number[],
    close():void,
}

const Confirm = (props:Props)=> {
    const classes = Styles.base();

    const name = props.girls[props.index].name;
    const height = String(props.girls[props.index].height)+"cm";
    const age = props.girls[props.index].age + "才";
    const profile = props.girls[props.index].profile;
    let lover = props.girls[ props.girls[props.index].lover ].name;
    if( props.girls[props.index].lover===props.index ){
        lover = props.lost
    }
    const textDataColor = classes.girlDataRowValue + " " + classes.girlTextActive;

    const type = props.girls[props.index].id % 20;
    let mes = "";
    if( type===0 ){
        mes = lover + "がスキ";
    } else if( type===1 ){
        mes = lover + "のことが気になる";
    } else if( type===2 ){
        mes = lover + "が好きだよ";
    } else if( type===3 ){
        mes = "え？気になるのは" + lover;
    } else if( type===4 ){
        mes = lover + "と一緒にいたい";
    } else if( type===5 ){
        mes = "私は" + lover + "を大切に思ってるよ";
    } else if( type===6 ){
        mes = "あたしと" + lover + "の邪魔をしないで";
    } else if( type===7 ){
        mes = lover + "とは仲良くしている、すごくね";
    } else if( type===8 ){
        mes = "あえて言うなら" + lover + "かな";
    } else if( type===9 ){
        mes = lover + "とはうまくやっていける…と思う";
    } else if( type===10 ){
        mes = lover + "に会いたい、いいだろ";
    } else if( type===11 ){
        mes = "うん、" + lover + "じゃないと";
    } else if( type===12 ){
        mes = lover + "には借りがある";
    } else if( type===13 ){
        mes = lover + "は私を待ってるはず";
    } else if( type===14 ){
        mes = "あたしと" + lover + "ってお似合いじゃない？";
    } else if( type===15 ){
        mes = "ああ、うん、" + lover + "かな、多分ね";
    } else if( type===16 ){
        mes = "僕は" + lover + "を愛す";
    } else if( type===17 ){
        mes = "誰でもいいけど" + lover + "だろうな";
    } else if( type===18 ){
        mes = lover + "を思うことが多いよ、わりと";
    } else if( type===19 ){
        mes = lover + "に会えて良かった";
    } else if( type===20 ){
        mes = lover + "と私だけいればいい";
    } else if( type===21 ){
        mes = "わたしには" + lover + "が必要だから";
    } else if( type===22 ){
        mes = lover + "とはいつも一緒だった、これからも";
    } else if( type===23 ){
        mes = "僕には" + lover + "がいる";
    } else if( type===24 ){
        mes = lover + "はあたしのことどう思うかな";
    } else if( type===25 ){
        mes = lover + "に見捨てられたら…どうしよう";
    } else if( type===26 ){
        mes = lover + "がいるから私は大丈夫";
    } else if( type===27 ){
        mes = lover + "が好きだって言ってもいい";
    } else if( type===28 ){
        mes = lover + "は私のことが好きなんだ、絶対";
    } else {
        mes = lover + "と私は特別なんだ";
    }

    let newGirl = false;
    if( props.girls[props.index].sleep && !props.unlockedIndex.includes(props.index) ){
        newGirl = true;
    }

    return (
        <div id="confirm" className={classes.modalRoot}>
            <ModalHead close={props.close}/>
            <Grid container spacing={1} onClick={props.close}>
                <Grid item xs={5}>
                    <div className={classes.girlPhoto}><img src={NoPhotoImage} alt="{name}" style={{width:"100%",border:"1px solid silver"}}/></div>
                </Grid>
                <Grid item xs={7}>
                    <div className={classes.girlDataSleeping}>
                        <span className={classes.withIcon}>{name}</span>
                    </div>
                    <div className={classes.girlProfile}>{profile}</div>
                    <div className={classes.girlDataRow}>
                        <div className={classes.girlDataRowName}>AGE:</div>
                        <div className={textDataColor}>{age}</div>
                    </div>
                    <div className={classes.girlDataRow}>
                        <div className={classes.girlDataRowName}>HEIGHT:</div>
                        <div className={textDataColor}>{height}</div>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div style={{textAlign:"center",marginTop:"2em",marginBottom:"5em",padding:"1em 0.5em",border:"1px solid silver",borderRadius:"1em"}}>
                        <Typography variant="subtitle2" style={{color:Theme.palette.secondary.dark}}>- 彼女の告白 -</Typography>
                        <div style={{marginTop:"1em",marginBottom:"1.5em"}}>{mes}</div>
                    </div>
                </Grid>
            </Grid>
            <div className={classes.modalBottom}>
                {newGirl ? (
                    <Button variant="contained" color="primary" style={{width:"100%"}} onClick={props.close}>そして</Button>
                ):(
                    <Button variant="outlined" color="default" style={{width:"100%"}} onClick={props.close}>閉じる</Button>
                )}
            </div>
        </div>
    );
}

export default Confirm;
